<template>
<div>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="5" style="margin:10px;">
            <vs-card>
                <div class="vx-col sm:w-full md:w-1/2">
                    <vs-avatar class="text-center" size="100px" :src="$data_url+'archivos/'+'perfil/'+usuarios.foto_user" />
                </div>
            </vs-card>
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="5" style="margin:10px;">
            <vs-card>
                <div class="vx-col w-full mt-5">
                    <vs-button ref="loadableButton" id="button-with-loading" class="vs-con-loading__container" @click="generarPassword(usuarios.email)" type="relief">
                        Resetear contraseña
                    </vs-button>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
    <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
            <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Nombres" v-model="usuarios.nombres" />
        </div>
        <div class="vx-col w-full sm:w-1/2">
            <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Apellidos" v-model="usuarios.apellidos" />
        </div>
    </div>
    <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
            <vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Cédula" v-model="usuarios.cedula" @keypress="validateInput" @paste="validatePaste"/>
        </div>
        <div class="vx-col w-full sm:w-1/2" v-if="userRoot">
            <vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Usuario" v-model="usuarios.name_usuario" />
        </div>
    </div>
    <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
            <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border label="Correo" v-model="usuarios.email" />
        </div>
        <div class="vx-col w-full sm:w-1/2">
            <vs-input class="w-full" type="tel" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Teléfono" v-model="usuarios.telefono" />
        </div>
    </div>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div class="vx-col w-full mt-5">
                    Perfil
                    <v-select :options="grupo" :reduce="grupo => grupo.id" label="deskripsi" v-model="usuarios.id_group"></v-select>
                </div>
                <div class="vx-col w-full mt-5" v-if="usuarios.id_group  == 1">
                    <div class="vx-col sm:w-2/3 w-full">
                        Capacitador:
                        <vs-radio class="m-2" color="success" v-model="usuarios.capacitador" vs-name="capacitador" vs-value="1">Si</vs-radio>
                        <vs-radio class="m-2" v-model="usuarios.capacitador" vs-name="capacitador" vs-value="0">No</vs-radio>
                    </div>
                </div>
                <div class="vx-col w-full mt-5">
                    <v-select :options="estado" :reduce="estado => estado.id" label="label" v-model="usuarios.estado_idEstado"></v-select>
                </div>
                <div class="vx-col w-full mt-5">
                    <v-select :disabled="desabilitar_boton" :options="instituciones" :reduce="instituciones => instituciones.id" label="label" v-model="usuarios.institucion_idInstitucion"></v-select>
                </div>
                <div  v-if="usuarios.id_group == 11 && userRoot" style="background-color: #DAE9FB; color: #1D79E9; font-size: 15px; padding: 7px; border-radius: 15px;">
                    <p v-if="userRoot">* El campo de <b>iniciales</b> se usa para registrar movimientos no operativos, actas, órdenes de producción, compras, proformas, facturas, notas y para realizar los pedidos.</p>
                    <p v-if="usuarios.id_group == 11 && userRoot">* El campo de <b>cli_ins_codigo</b> es el id de la tabla cliente_institucion de facturación donde se relaciona con la institución llamada prolipa Plataforma y el asesor </p>
                </div>
                <br>
                <div class="vx-row mb-6" v-if="userRoot">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Iniciales</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="tel" icon-pack="feather" icon="icon-check" icon-no-border v-model="usuarios.iniciales" />
                    </div>
                </div>


                <div class="vx-row mb-4" v-if="usuarios.id_group == cargoIdTemporal">
                    <div  class="vx-col sm:w-1/3 w-full">
                      <div class="flex">
                        <span class="mr-2">Cargo</span>
                        <vs-button color="success" icon="add" @click="popupAddCargo = true" class="ml-5 p-2" type="relief">Añadir cargo</vs-button>
                      </div>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <v-select :options="cargos" :reduce="cargos => cargos.id" label="cargo" class="w-full" v-model="usuarios.cargo_id" />
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="usuarios.id_group == 11 && userRoot">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Cliente ins_codigo</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="tel" icon-pack="feather" icon="icon-check" icon-no-border label="Cliente Facturación id" v-model="usuarios.cli_ins_codigo" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                      <span>Fecha Nacimiento</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                        <flat-pickr :config="configdateTimePicker" v-model="usuarios.fecha_nacimiento" placeholder="Fecha Nacimiento" class="m-1" style="display: inline-block;width: 100%" />
                  </div>
                </div>
            </vs-card>
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10" style="margin:10px;" v-if="validacionVentas">
            <vs-card>
                <!-- Alerta visual dentro de la tarjeta -->
                <vs-alert color="danger" icon="warning">
                    <strong>¡Atención!</strong> Este usuario ya cuenta con ventas al RUC/CI: {{ rucOriginal }}.
                </vs-alert>
                <div class="vx-col w-full mt-5">
                    <vs-table :data="datosUsuarioVentas" style="width: 100%;" color="danger">
                        <template slot="thead">
                            <vs-th>Documento</vs-th>
                            <vs-th>Empresa</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr v-for="item in data" :key="item.ven_codigo">
                                <vs-td>{{ item.ven_codigo }}</vs-td>
                                <vs-td>{{ item.id_empresa == 1 ? 'Prolipa' : 'Calmed' }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vs-card>
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10" style="margin:10px;">
            <vs-card>
                <div class="vx-col w-full mt-5">
                    <vs-button color="success" @click="verificarUsuarioGuardado" style="width:100%;" type="filled">Guardar</vs-button>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
    <!--Modal añadir cargos-->
    <vs-popup background-color="rgba(255,255,255,.6)" title="Añadir cargos" :active.sync="popupAddCargo" class="informacionformhijo">
        <vs-table max-items="5" search pagination :data="cargos" v-if="editCargo == false">
            <template slot="header">
                <div>
                    <vs-button type="line" style="border-radius: 10px;" icon="add" @click="editCargo = true;limpiar();update=false;">Añadir</vs-button>
                </div>
            </template>
            <template slot="thead">
                <vs-th>Cargo</vs-th>
                <vs-th style="width:100px;">Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].cargo}}<br>
                    </vs-td>
                    <vs-td>
                        <div style="display:flex;">
                            <vx-tooltip style="display: inline-block;" text="Editar cargo" position="top" color="primary">
                                <vs-button size="small" class="modal-default-button" color="success" @click="editarCargo(tr);update=true" type="filled" icon-pack="feather" icon="icon-edit"> </vs-button>
                            </vx-tooltip> &nbsp;

                            <div>
                                <vx-tooltip v-if="tr.estado == 1" style="display: inline-block;" text="Desactivar cargo" position="top" color="primary">
                                    <vs-button size="small" class="modal-default-button" color="danger" @click="openConfirmCargo(tr,0);" icon-pack="feather" type="filled" icon="icon-trash"> </vs-button>
                                </vx-tooltip> &nbsp;

                                <vx-tooltip v-if="tr.estado == 0 && usuario.id_group == 1" style="display: inline-block;" text="Activar cargo" position="top" color="primary">
                                    <vs-button size="small" class="modal-default-button" color="warning" @click="openConfirmCargo(tr,1);" icon-pack="feather" type="filled" icon="icon-check"> </vs-button>
                                </vx-tooltip> &nbsp;

                            </div>

                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!--PARA EDITAR CARGO-->
        <div v-if="editCargo == true">
            <vs-button radius color="success" type="filled" @click="editCargo = false" icon="reply"></vs-button>
            <vs-row class="mt-4">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <vs-input label="Cargo" class="w-full" placeholder="Cargo" v-model="cargo.cargo" />
                </vs-col>
            </vs-row>
            <vs-row class="mt-5">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <vs-button color="success" @click="guardarCargo()" type="relief">Guardar</vs-button>
                </vs-col>
            </vs-row>
        </div>
    </vs-popup>
</div>
</template>


<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'
export default {
    data() {
        return {
            usuario: [],
            estado: [{
                    id: 1,
                    label: "Activo"
                },
                {
                    id: 2,
                    label: "Bloqueado"
                },
                {
                    id: 4,
                    label: "Eliminado"
                }
            ],
            cargos: [],
            grupo: [],
            configdateTimePicker: {
                enableTime: true,
                dateFormat: 'Y-m-d'
            },
            desabilitar_boton: false,
            userRoot: false,
            // validacion usuario con Ventas
            validacionVentas: false,
            rucOriginal:null,
            datosUsuarioVentas: [],
            //variables para el modal de añadir cargos
            cargoIdTemporal: 660,
            popupAddCargo:false,
            editCargo: false,
            cargos: [],
            cargo: {
                id: '',
                cargo: '',
                estado: '',
            }
        }
    },
    components: {
        flatPickr,
        vSelect,
    },
    props: {
        usuarios: {
            type: Object,
            default: {},
        },
        instituciones: {
            type: Array,
            default: [],
        },
    },
    created() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem("usuario"))
        me.getCargos()
        me.getPerfiles()
    },
    mounted() {
        let me = this
        // Verifica si el prop usuarios existe antes de asignarlo
        if (this.usuarios && this.usuarios.cedula) {
            this.rucOriginal = this.usuarios.cedula;
            console.log("RUC Original:", this.rucOriginal);
        } else {
            console.warn("Prop 'usuarios' aún no está disponible en mounted.");
        }
        me.getUserRoot(me.usuario)
    },
    watch: {
        'usuarios.iniciales': function (newVal) {
            // Asegúrate de que el valor en el input sea siempre en mayúsculas y no más de 10 caracteres
            if (newVal.length > 10) {
                this.usuarios.iniciales = newVal.slice(0, 10).toUpperCase();
            } else {
                this.usuarios.iniciales = newVal.toUpperCase();
            }
        }
    },
    methods: {
        validateInput(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        validatePaste(event) {
            event.preventDefault();
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('text/plain');

            // Filtrar solo números
            const numbersOnly = pastedText.replace(/\D/g, '');

            // Obtener el input donde se está pegando
            const input = event.target;
            const start = input.selectionStart;
            const end = input.selectionEnd;

            // Insertar el texto en la posición actual del cursor
            this.usuarios.cedula =
                this.usuarios.cedula.slice(0, start) +
                numbersOnly +
                this.usuarios.cedula.slice(end);

            // Mover el cursor al final del texto insertado
            this.$nextTick(() => {
                input.selectionStart = input.selectionEnd = start + numbersOnly.length;
            });
        },
        verificarUsuarioGuardado(){
            let me = this;
            if(this.rucOriginal == this.usuarios.cedula){
                this.guardar();
            }else{
                this.$http.get(this.$server_url + 'usuarioConVentas/' + this.rucOriginal)
                .then((result) => {
                    if (result.data.SinVentas) {
                        this.guardar();
                    }else{
                        this.$vs.notify({
                            text: 'El usuario tiene ventas registradas no se puede cambiar el ruc: '+this.rucOriginal,
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        this.validacionVentas = true;
                        this.datosUsuarioVentas = result.data.ventas;
                        this.usuarios.cedula = this.rucOriginal;
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        getUserRoot(dato) {
            let me = this;
            this.$http.get(this.$server_url + 'permisos/' + dato.idusuario)
                .then((result) => {
                    if (result.data.length > 0) {
                        me.userRoot = true;
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        getPerfiles() {
          let me = this;
          this.$http.get(this.$server_url + 'obtenerPerfiles?id_group=' + me.usuario.id_group)
            .then(function (response) {
                me.grupo = response.data;
                let grupoNuevo = {
                  id:me.cargoIdTemporal,
                  level:'Autoridad',
                  deskripsi:'Autoridad',
                }
                me.grupo.push(grupoNuevo);
            })
            .catch(function (error) {})
        },
        getCargos() {
            let me = this;
            this.$http.get(this.$server_url + 'traerCargos')
                .then(function (response) {
                    me.cargos = response.data;
                    if(me.usuarios.cargo_id > 0){
                      me.usuarios.id_group = me.cargoIdTemporal;
                    }
                })
                .catch(function (error) {})
        },
        async guardar() {
            let me = this
            me.btn = false;
            me.$vs.loading({
                color: '#046AE7'
            })
            let formData = new FormData();
            formData.append('idusuario', this.usuarios.idusuario);
            formData.append('cedula', this.usuarios.cedula);
            formData.append('nombres', this.usuarios.nombres);
            formData.append('apellidos', this.usuarios.apellidos);
            formData.append('email', this.usuarios.email);
            if (me.userRoot) {
                formData.append('name_usuario', this.usuarios.name_usuario);
            } else {
                formData.append('name_usuario', this.usuarios.email);
            }
            formData.append('estado_idEstado', this.usuarios.estado_idEstado);
            formData.append('institucion_idInstitucion', this.usuarios.institucion_idInstitucion);
            formData.append('id_group', me.usuarios.id_group == me.cargoIdTemporal ? 6 : me.usuarios.id_group);
            formData.append('capacitador', this.usuarios.capacitador);
            formData.append('cli_ins_codigo', this.usuarios.cli_ins_codigo)
            formData.append('fecha_nacimiento', this.usuarios.fecha_nacimiento || '');
            formData.append('cargo_id', me.usuarios.cargo_id || '');
            formData.append('telefono', me.usuarios.telefono || '');
            formData.append('iniciales', me.usuarios.iniciales || '');

            this.$http.post(this.$server_url + 'usr', formData)
                .then(function (response) {
                    // console.log(response.data)
                    me.$vs.loading.close();
                    me.$vs.notify({
                        text: 'Usuario guardado',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-user'
                    })
                    me.$emit('saveChange', true)
                })
                .catch(function (error) {
                    if (error.response && error.response.status === 500 && error.response.data.message.includes('Duplicate entry')) {
                        // Capturamos el mensaje de error específico de duplicación
                        let errorMessage = 'Ya existe un registro con esas iniciales.';

                        // Notificamos al usuario del error
                        me.$vs.notify({
                            text: errorMessage,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                        me.$vs.loading.close();
                    } else {
                        console.log(error + ' error');
                        me.$vs.loading.close();
                    }
                })
        },
        generarPassword() {
            let me = this;
            let formData = new FormData();
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: "#button-with-loading",
                scale: 0.45
            })
            formData.append('idusuario', this.usuarios.idusuario);
            this.$http.post(this.$server_url + 'restaurarPasswordXIdUser', formData)
                .then(function (response) {
                    me.$vs.notify({
                        text: 'Use el número de cédula para acceder al perfil del usuario.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-lock'
                    })
                    me.$vs.loading.close("#button-with-loading > .con-vs-loading")
                })
                .catch(function (error) {
                    me.$vs.notify({
                        text: 'Error en el proceso',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-lock'
                    })
                    me.$vs.loading.close("#button-with-loading > .con-vs-loading")
                })
        },
        //metodos para cargo
        limpiar() {
              let me = this;
              me.cargo.id = "";
              me.cargo.cargo = "";
          },
          editarCargo(tr) {
              let me = this;
              me.cargo.id = tr.id
              me.cargo.cargo = tr.cargo
              me.editCargo = true
          },
          openConfirmCargo(tr, estado) {
              let me = this;
              me.popupAddCargo = false;
              me.cargo.id = tr.id
              me.cargo.estado = estado
              this.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: `Confirmar`,
                  text: 'Estas seguro de eliminar el cargo',
                  accept: this.eliminarCargo,
                  cancel: this.cancelar
              })
          },
         cancelar() {
              let me = this;
              me.popupAddCargo = true
          },
          eliminarCargo() {
              let me = this;
              let formData = new FormData();
              formData.append('id', me.cargo.id)
              formData.append('estado', me.cargo.estado)
              formData.append('eliminar', "yes")
              formData.append('usuario_id', me.usuario.idusuario)
              me.$vs.loading()
              this.$http.post(this.$server_url + 'cargo', formData)
                  .then(res => {
                      me.$vs.loading.close()
                      if(res.data.status == 0){
                          me.$vs.notify({
                              text: res.data.message,
                              color: 'warning',
                              iconPack: 'feather',
                              icon: 'icon-check'
                          })
                          return;
                      }
                      me.getCargos();
                      me.popupAddCargo = true
                      me.editCargo = false
                      me.$vs.notify({
                          text: res.data.message,
                          color: 'success',
                          iconPack: 'feather',
                          icon: 'icon-check'
                      })
                  })
                  .catch(function (error) {
                      me.$vs.loading.close()
                  })
          },
          guardarCargo() {
              let me = this;
              if (me.cargo.cargo == "") {
                  me.$vs.notify({
                      text: 'Debe agregar un cargo para guardar',
                      color: 'success',
                      iconPack: 'feather',
                      icon: 'icon-check'
                  })
                  return false
              }
              let formData = new FormData();
              if (me.update == true) {
                  formData.append('id', me.cargo.id)
              }
              formData.append('cargo', me.cargo.cargo)
              formData.append('usuario_id', me.usuario.idusuario)
              me.$vs.loading()
              this.$http.post(this.$server_url + 'cargo', formData)
                  .then(res => {
                      me.getCargos();
                      me.editCargo = false
                      me.$vs.loading.close()
                      me.$vs.notify({
                          text: res.data.message,
                          color: 'success',
                          iconPack: 'feather',
                          icon: 'icon-check'
                      })
                  })
                  .catch(function (error) {
                      me.$vs.loading.close()
                  })
          },
    }
}
</script>
<style scoped>
.informacionformhijo {
    z-index: 51002;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */
}
</style>
